import {
  SET_NEWS_LETTER_SUBSCRIPTION_DATA,
  RESET_NEWS_LETTER_SUBSCRIPTION_DATA,
  SET_FOOTER_DATA
} from "../constants";

type FooterState = {
  newsletterSubscription: {
    email: string;
  };
  content: any;
};

const initialState: FooterState = {
  newsletterSubscription: {
    email: ""
  },
  content: {}
};

const setFooter = (state: FooterState, { content }) => ({
  ...state,
  content: content
});

const setNewsletterSubscription = (state: FooterState, action) => {
  return {
    ...state,
    newsletterSubscription: action.newsletter
  };
};

const resetNewsletterSubscription = (state: FooterState) => {
  return {
    ...state,
    newsletterSubscription: initialState.newsletterSubscription
  };
};

const footerReducer = (
  state: FooterState = initialState,
  action
): FooterState => {
  switch (action.type) {
    case SET_FOOTER_DATA:
      return setFooter(state, action);
    case SET_NEWS_LETTER_SUBSCRIPTION_DATA:
      return setNewsletterSubscription(state, action);
    case RESET_NEWS_LETTER_SUBSCRIPTION_DATA:
      return resetNewsletterSubscription(state);
    default:
      return state;
  }
};
export default footerReducer;
